export default "__VITE_ASSET__b95fdf17__"